/* global organigramEventId organigramFilterPreference organigramContext */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import VenueOrganigram from './VenueOrganigram';

export default function VenueOrganigramIndex(props) {
    return (
        <div className="tw-h-full tw-px-6 tw-py-6.5 tw-rounded-lg tw-shadow-primary">
            <VenueOrganigram
                type={props.type}
                fetchUrl={props.fetchUrl}
                treeUpdateUrl={props.treeUpdateUrl}
                unassignedUrl={props.unassignedUrl}
                subFetchUrl={props.subFetchUrl}
                costcenters={props.costcenters}
                organisationChartTabActive={props.organisationChartTabActive}
                eventId={props.eventId}
                initialFilterState={props.initialFilterState}
                fullPreferenceValue={props.fullPreferenceValue}
                exportContext={props.exportContext}
            />
        </div>
    );
}

// Expose a global function for lazy loading the component
window.loadVenueOrganigram = function (fetchUrl, treeUpdateUrl, type, unassignedUrl) {
    if (document.getElementById('VenueOrganigram')) {
        var rootEl = document.getElementById('VenueOrganigram');
        var eventId = typeof organigramEventId !== 'undefined' ? organigramEventId : null;
        var filterPreference = typeof organigramFilterPreference !== 'undefined' ? organigramFilterPreference : {};
        var exportContext = typeof organigramContext !== 'undefined' ? organigramContext : {};
        ReactDOM.render(
            <App>
                <VenueOrganigramIndex
                    fetchUrl={fetchUrl}
                    treeUpdateUrl={treeUpdateUrl}
                    unassignedUrl={unassignedUrl || ''}
                    subFetchUrl={''}
                    type={type}
                    costcenters={'[]'}
                    organisationChartTabActive={true}
                    eventId={eventId}
                    initialFilterState={filterPreference}
                    fullPreferenceValue={filterPreference}
                    exportContext={exportContext}
                />
            </App>,
            rootEl,
        );
    }
};
